import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export type FloatingTypes =
    | 'balance_up' //  number
    | 'balance_down' // number
    | 'league_join' // league id
    | 'api_key_has' // exchange (binance, bitmex...)
    | 'copy_never_used' // true (한 번도 카피트레이딩을 하지 않음)
    | 'copy_running' // true (카피 트레이딩을 진행 중인지)
    | 'copy_deleted' // true (카피를 했다가 끊긴건지)
    | 'pro_never_used' // true (한 번도 프로를 하지 않음)
    | 'pro_running' // true (프로를 진행 중인지)
    | 'pro_deleted' // true (프로를 했다가 끊긴건지)
    | string

export const getFloatingType = async (): Promise<ApiRes<FloatingTypes[]>> => {
    return await apiGet(API_URL, `admin/floating/types`)
}
